import { render, staticRenderFns } from "./number-port.vue?vue&type=template&id=4c73e8e7"
import script from "./number-port.vue?vue&type=script&lang=js"
export * from "./number-port.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports